import { memo, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// Local files
import { Root } from './ActionsPanel.styled';
import General from './General/General';
import Appointments from './Appointments/Appointments';
import Info from './Info/Info';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const ActionsPanel = () => {
  const [tab, setTab] = useState('general');
  const [processing, /*setProcessing*/] = useState(false);

  return (
    <Root>
      <Tabs
        allowScrollButtonsMobile
        centered
        value={tab}
        onChange={(_, newValue) => setTab(newValue)}
      >
        <Tab disabled={processing} value='general' label='Settings' sx={{ fontWeight: 600 }} />
        <Tab disabled={processing} value='appointments' label='Appointments' sx={{ fontWeight: 600 }} />
        <Tab disabled={processing} value='info' label='Info' sx={{ fontWeight: 600 }} />
      </Tabs>
      {tab === 'general' && !processing && <General />}
      {tab === 'appointments' && !processing && <Appointments />}
      {tab === 'info' && !processing && <Info />}
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ActionsPanel {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);